import React from "react";
import {
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  FormControl,
  MenuItem,
  Select,
  Button,
  Pagination,
  Paper,
  CircularProgress 
} from "@mui/material";

const JobDetailTable = ({
  selectedJob,
  searchQueryDtl,
  setSearchQueryDtl,
  rowsDtlPerPage,
  handleChangeRowsDtlsPerPage,
  paginatedProcessesDtl,
  handleJobClickDtl,
  totalPagesDtl,
  pageDtl,
  handleChangePageDtl,
  handleBack,
  loading
}) => {
	

return (
    <>
      <Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: "20px" }}>
        Job Instances for Job:   {selectedJob}
      </Typography>

      <TextField
        size="small"
        label="Search"
        value={searchQueryDtl}
        onChange={(e) => setSearchQueryDtl(e.target.value)}
        sx={{ flex: 1, mr: 2 }}
      />

      <div style={{ display: "flex", alignItems: "center", margin: "20px 0" }}>
        <Typography variant="body1">Rows per page:</Typography>
        <FormControl size="small">
          <Select value={rowsDtlPerPage} onChange={handleChangeRowsDtlsPerPage}>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </FormControl>
      </div>


     <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Job Instance ID</TableCell>
              <TableCell>Job Execution Count</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Start Date</TableCell>
              <TableCell>Start Time</TableCell>
              <TableCell>Job Execution Duration</TableCell>
              <TableCell>Job Execution Parameter</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
							<TableRow>
								<TableCell colSpan={8} align="center">
									<Box display="flex" alignItems="center" justifyContent="center" p={3}>
										<Typography variant="body2" mr={2}>Loading...</Typography>
										<CircularProgress size={24} />
									</Box>
								</TableCell>
							</TableRow>
						) :paginatedProcessesDtl.length > 0 ? (
              paginatedProcessesDtl.map((detail, idx) => (
                <TableRow key={idx}>
                  <TableCell>
                    <Typography
                      variant="body2"
                      onClick={() => handleJobClickDtl(detail.batchId)}
                      sx={{
                        cursor: "pointer",
                        color: "blue",
                        textDecoration: "underline",
                      }}
                    >
                      {detail.batchId}
                    </Typography>
                  </TableCell>
                  <TableCell>{detail.exeCnt}</TableCell>
                  <TableCell>{detail.lastExecStts}</TableCell>
                  <TableCell>{detail.lastExecDate}</TableCell>
                  <TableCell>{detail.lastExecStar}</TableCell>
                  <TableCell>{detail.lastExecDuration}</TableCell>
                  <TableCell>{detail.jobParam}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ fontWeight: "bold" }}>
                  No results found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Box display="flex" justifyContent="right" mt={3}>
        <Pagination
          count={totalPagesDtl}
          page={pageDtl}
          onChange={handleChangePageDtl}
          color="primary"
          showFirstButton
          showLastButton
        />
      </Box>
      <Box display="flex" justifyContent="center" mt={2}>
        <Button variant="outlined" color="primary" onClick={handleBack}>
          Back
        </Button>
      </Box>
    </>
  );
};


export default JobDetailTable;
